/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DocumentSubType,
    DocumentSubTypeFromJSON,
    DocumentSubTypeToJSON,
    DocumentType,
    DocumentTypeFromJSON,
    DocumentTypeToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models';

export interface DocumentAdminTestDocumentTemplateRequest {
    jurisdictionId?: string;
    documentType?: DocumentType;
    documentSubType?: DocumentSubType;
    firmId?: string;
    template?: Blob;
}

export interface DocumentAdminUploadFirmLogoRequest {
    firmId?: string;
    jurisdictionId?: string;
    logo?: Blob;
}

export interface DocumentAdminUploadFirmTemplateRequest {
    firmId?: string;
    jurisdictionId?: string;
    templateType?: string;
    template?: Blob;
}

/**
 * 
 */
export class DocumentAdminApi extends runtime.BaseAPI {

    /**
     */
    async documentAdminTestDocumentTemplateRaw(requestParameters: DocumentAdminTestDocumentTemplateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.jurisdictionId !== undefined) {
            queryParameters['jurisdictionId'] = requestParameters.jurisdictionId;
        }

        if (requestParameters.documentType !== undefined) {
            queryParameters['documentType'] = requestParameters.documentType;
        }

        if (requestParameters.documentSubType !== undefined) {
            queryParameters['documentSubType'] = requestParameters.documentSubType;
        }

        if (requestParameters.firmId !== undefined) {
            queryParameters['firmId'] = requestParameters.firmId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.template !== undefined) {
            formParams.append('template', requestParameters.template as any);
        }

        const response = await this.request({
            path: `/api/DocumentAdmin/test-document-template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async documentAdminTestDocumentTemplate(requestParameters: DocumentAdminTestDocumentTemplateRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.documentAdminTestDocumentTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentAdminUploadFirmLogoRaw(requestParameters: DocumentAdminUploadFirmLogoRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.firmId !== undefined) {
            queryParameters['firmId'] = requestParameters.firmId;
        }

        if (requestParameters.jurisdictionId !== undefined) {
            queryParameters['jurisdictionId'] = requestParameters.jurisdictionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.logo !== undefined) {
            formParams.append('logo', requestParameters.logo as any);
        }

        const response = await this.request({
            path: `/api/DocumentAdmin/upload-firm-logo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentAdminUploadFirmLogo(requestParameters: DocumentAdminUploadFirmLogoRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentAdminUploadFirmLogoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async documentAdminUploadFirmTemplateRaw(requestParameters: DocumentAdminUploadFirmTemplateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.firmId !== undefined) {
            queryParameters['firmId'] = requestParameters.firmId;
        }

        if (requestParameters.jurisdictionId !== undefined) {
            queryParameters['jurisdictionId'] = requestParameters.jurisdictionId;
        }

        if (requestParameters.templateType !== undefined) {
            queryParameters['templateType'] = requestParameters.templateType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.template !== undefined) {
            formParams.append('template', requestParameters.template as any);
        }

        const response = await this.request({
            path: `/api/DocumentAdmin/upload-firm-template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async documentAdminUploadFirmTemplate(requestParameters: DocumentAdminUploadFirmTemplateRequest, initOverrides?: RequestInit): Promise<void> {
        await this.documentAdminUploadFirmTemplateRaw(requestParameters, initOverrides);
    }

}
